var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.774318 14.1174C-0.258106 15.1587 -0.258106 16.8497 0.774318 17.8909L13.9893 31.2191C15.0218 32.2603 16.6984 32.2603 17.7308 31.2191C18.7633 30.1778 18.7633 28.4868 17.7308 27.4455L9.01719 18.6656H34.357C35.8189 18.6656 37 17.4744 37 16C37 14.5256 35.8189 13.3344 34.357 13.3344H9.02545L17.7226 4.55447C18.755 3.51321 18.755 1.8222 17.7226 0.780945C16.6902 -0.260315 15.0135 -0.260315 13.9811 0.780945L0.766058 14.1091L0.774318 14.1174Z",
    fill: "#E52A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.c899fca56c4d7c894ac9f01402bbb812.svg";
export { ForwardRef as ReactComponent };